import { useNavigate } from "react-router-dom";
import CommonToggle from "../CommonToggle";

/**
 * ConfidentialCard Component
 *
 * @description
 * Displays a card with an icon, title, description note, and a toggle switch.
 * Supports disabled state, preview mode, and redirects to a "feature not
 * assigned" screen when unavailable.
 *
 * @param {string} icon - Icon or image to display on the left.
 * @param {string} title - Main label of the card.
 * @param {string} note - Supporting descriptive text below the title.
 *
 * @param {boolean} [isEnabled=true] - Whether the toggle/card is enabled.
 * @param {boolean} [toggleState=false] - Current toggle ON/OFF state.
 * @param {Function} onToggle - Called when toggle is switched.
 *
 * @param {string} unavailableService - Service name for blocked feature routing.
 * @param {boolean} [isPreview=false] - If true, disables interaction.
 */

const ConfidentialCard = ({
  icon,
  title,
  note,
  isEnabled = true,
  toggleState = false,
  onToggle = () => {},
  unavailableService,
  isPreview = false,
}) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    if (isPreview) return;
    if (!isEnabled && unavailableService) {
      navigate("/feature_not_assigned", {
        state: { unavailableService },
      });
    }
  };

  return (
    <div
      className={`w-width-full flex flex-col relative global-card-create ${
        isEnabled
          ? "cursor-default opacity-base-opacity"
          : "cursor-not-allowed opacity-light-opacity"
      }
  `}
      onClick={handleCardClick}
    >
      <div className="w-width-full">
        <div className="flex flex-row gap-gap-sm">
          <img
            src={icon}
            alt="icon"
            className="w-icon-md h-icon-md mt-margin-xs"
          />
          <p className="font-semibold text-base text-text-primary">{title}</p>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            <div className="flex items-start gap-gap-sm">
              <div className="border-r border-primary-bg pr-padding-md">
                <p className="text-font-xs text-text-secondary mt-margin-xs">
                  {note}
                </p>
              </div>
            </div>
          </div>

          <div
            className="ml-margin-md"
            onClick={(e) => e.stopPropagation()}
          >
            <div>
              <CommonToggle
                state={toggleState}
                isDisabled={isPreview ? true : !isEnabled}
                handleClick={(e) => {
                  if (isPreview) return;
                  e.stopPropagation();
                  onToggle();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfidentialCard;
